import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface ISubscriptionCheck {
  id?: string;
  oneDay?: boolean;
  threeDays?: boolean;
  sevenDays?: boolean;
  url?: string;
  lastShipment?: string;
  planOptionFound?: boolean;
  planUrl?: string;
}
export interface IGlobal {
  welcome?: boolean;
  subscriptionCheck?: ISubscriptionCheck;
  tutorialMode?: boolean;
  tutorialCurrentStep?: number;
  showLoginModal?: boolean;
  showApprovalPendingModal?: boolean;
  qaClient?: boolean;
  membershipUsersReqTrigger?: number;
}

const initialState: IGlobal = {
  welcome: false,
  subscriptionCheck: {
    oneDay: false,
    threeDays: false,
    sevenDays: false,
    url: "",
    lastShipment: "",
    planOptionFound: false,
    planUrl: "",
  },
  tutorialMode: false,
  tutorialCurrentStep: 1,
  showLoginModal: false,
  showApprovalPendingModal: false,
  qaClient: true,
  membershipUsersReqTrigger: 0,
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    set: (state, action: PayloadAction<IGlobal>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { set } = globalSlice.actions;

export default globalSlice.reducer;
